import * as React from 'react'
import { Tag, Intent } from '@blueprintjs/core'
import { toTitleCase } from '../../../../utils'
import { PaymentStatus } from '../../types'

export interface PaymentStatusTagProps {
  value: PaymentStatus
}

const highlightMap = {
  [PaymentStatus.PAID]: Intent.SUCCESS,
  [PaymentStatus.UNPAID]: Intent.NONE,
  [PaymentStatus.PARTIALLY_PAID]: Intent.SUCCESS,
  [PaymentStatus.REFUNDED]: Intent.NONE,
  [PaymentStatus.PARTIALLY_REFUNDED]: Intent.NONE
}

const PaymentStatusTag: React.FC<PaymentStatusTagProps> = props => {
  return (
    <Tag round minimal intent={highlightMap[props.value]}>
      {toTitleCase(props.value)}
    </Tag>
  )
}
export default PaymentStatusTag
